// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProcessingOrder_wrapper__z5qme","icon":"ProcessingOrder_icon__la6hj"};